import { type QueryKey, skipToken, useQuery } from '@tanstack/react-query';
import { isObject } from 'lodash';

import { SavedFilters } from '@air/api';

export const PRIVATE_SAVED_SEARCH_LIST_KEY = 'PRIVATE_SAVED_SEARCH_LIST';

export type PrivateSavedSearchListKey = [typeof PRIVATE_SAVED_SEARCH_LIST_KEY, UsePrivateSavedSearchListParams];

export const getPrivateSavedSearchListKey = (params: UsePrivateSavedSearchListParams): PrivateSavedSearchListKey => {
  return [PRIVATE_SAVED_SEARCH_LIST_KEY, params];
};

export const isPrivateSavedSearchListKey = (key: QueryKey): key is PrivateSavedSearchListKey => {
  return Array.isArray(key) && key[0] === PRIVATE_SAVED_SEARCH_LIST_KEY && isObject(key[1]);
};

export type UsePrivateSavedSearchListParams = Omit<
  Parameters<typeof SavedFilters.listSavedFilters>[0],
  'workspaceId'
> & {
  workspaceId: string | undefined;
};

export type UsePrivateSavedSearchListOptions = { enabled?: boolean };

export const usePrivateSavedSearchList = (
  params: UsePrivateSavedSearchListParams,
  options?: UsePrivateSavedSearchListOptions,
) => {
  const { workspaceId } = params;

  return useQuery({
    queryKey: getPrivateSavedSearchListKey(params),
    queryFn: !workspaceId ? skipToken : () => SavedFilters.listSavedFilters({ ...params, workspaceId }),
    enabled: options?.enabled && !!workspaceId,
  });
};
